import React from "react";
// Styles
import { withStyles } from "@material-ui/core/styles";
import green from "@material-ui/core/colors/green";
import amber from "@material-ui/core/colors/amber";
import classnames from "classnames";
// Material Ui core
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import IconButton from "@material-ui/core/IconButton";
// Material Ui icons
import CloseIcon from "@material-ui/icons/Close";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import WarningIcon from "@material-ui/icons/Warning";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";

const TRANSITION_DOWN_DURATION = 200;
const TRANSITION_DELAY = 150;

export const muiClasses = {
  root: {},
  anchorOriginTopCenter: {},
  anchorOriginBottomCenter: {},
  anchorOriginTopRight: {},
  anchorOriginBottomRight: {},
  anchorOriginTopLeft: {},
  anchorOriginBottomLeft: {}
};

export const styles = theme => ({
  ...muiClasses,
  idle: {
    display: "hide"
  },
  success: {
    backgroundColor: green[600]
  },
  error: {
    backgroundColor: theme.palette.error.dark
  },
  info: {
    backgroundColor: theme.palette.primary.dark
  },
  warning: {
    backgroundColor: amber[700]
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1)
  },
  message: {
    alignItems: "center"
  },
  container: {
    flex: "1"
  },
  root: {
    display: "flex"
  }
});

const DIRECTION = {
  right: "left",
  left: "right",
  bottom: "up",
  top: "down"
};

class SnackbarItem extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  getTransitionStyles = (offset, anchorOrigin) =>
    Object.assign(
      {
        [anchorOrigin.vertical]: offset
      },
      {
        WebKitTransition: `all ${TRANSITION_DOWN_DURATION}ms`,
        MozTransition: `all ${TRANSITION_DOWN_DURATION}ms`,
        msTransition: `all ${TRANSITION_DOWN_DURATION}ms`,
        OTransition: `all ${TRANSITION_DOWN_DURATION}ms`,
        transition: `all ${TRANSITION_DOWN_DURATION}ms`,
        transitionDelay: `${TRANSITION_DELAY}ms`
      }
    );

  getTransitionDirection = anchorOrigin => {
    if (anchorOrigin.horizontal !== "center") {
      return DIRECTION[anchorOrigin.horizontal];
    }
    return DIRECTION[anchorOrigin.vertical];
  };

  handleClose = key => (event, reason) => {
    const {
      onClose,
      snack: { onClose: singleOnClose }
    } = this.props;
    if (reason === "clickaway") return;
    if (singleOnClose) singleOnClose(event, reason, key);
    onClose(event, reason, key);
  };

  handleExited = key => event => {
    const {
      onExited,
      snack: { onExited: singleOnExited }
    } = this.props;
    if (singleOnExited) singleOnExited(event, key);
    onExited(event, key);
  };

  getIcon = (variant, classes) => {
    const Icon = {
      success: CheckCircleIcon,
      warning: WarningIcon,
      error: ErrorIcon,
      info: InfoIcon,
      idle: InfoIcon
    }[variant];

    return <Icon className={classes} />;
  };

  componentDidMount = () => {
    const { onSetHeight, snack } = this.props;
    const height = this.ref.current && this.ref.current.clientHeight;
    onSetHeight(snack.key, height);
  };

  render() {
    const {
      classes,
      autoHideDuration,
      action,
      anchorOrigin,
      ContentProps = {},
      hideIconVariant,
      preventDuplicate,
      iconVariant,
      offset,
      snack,
      style,
      onSetHeight,
      ...other
    } = this.props;

    const { action: contentAction, className, ...otherContentProps } = ContentProps;

    const {
      key,
      persist,
      variant = "default",
      action: singleAction,
      ContentProps: singleContentProps = {},
      ...singleSnackProps
    } = snack;

    const contentProps = {
      ...otherContentProps,
      ...singleContentProps,
      action: singleAction || singleContentProps.action || contentAction || action
    };

    return (
      <Snackbar
        key={snack.key}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
        TransitionProps={{
          direction: this.getTransitionDirection({ vertical: "bottom", horizontal: "center" })
        }}
        style={{
          ...style,
          ...this.getTransitionStyles(offset, { vertical: "bottom", horizontal: "center" })
        }}
        autoHideDuration={autoHideDuration}
        open={snack.open}
        onClose={this.handleClose(key)}
        onExited={this.handleExited(key)}
      >
        <SnackbarContent
          className={classes[snack.message.type]}
          classes={{ message: classes.container, root: classes.root }}
          aria-describedby="client-snackbar"
          message={
            <span id="client-snackbar" className={classes.message} style={{ display: "flex" }}>
              {this.getIcon(snack.message.type, classnames(classes.icon, classes.iconVariant))}
              <span>{snack.message.content}</span>
            </span>
          }
          action={[
            <IconButton key="close" aria-label="Close" color="inherit" onClick={this.handleClose(key)}>
              <CloseIcon className={classes.icon} />
            </IconButton>
          ]}
        />
      </Snackbar>
    );
  }
}

export default withStyles(styles)(SnackbarItem);
